module.exports = __webpack_public_path__ + "ef9c79c87b49286ccf90cfc38124d8a8.jpg";